import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-all-budget-requests',
  templateUrl: './all-budget-requests.component.html',
  styleUrls: ['./all-budget-requests.component.scss']
})
export class AllBudgetRequestsComponent implements OnInit {
  value: number = 0;
  products: Product[];
  items: MenuItem[];
  displayBasic: boolean;
  rangeDates: Date[];
  minDate: Date;
  maxDate: Date;
  es: any;
  invalidDates: Array<Date>

  constructor(private productService: ProductService) { }
  

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
  let interval = setInterval(() => {
    this.value = this.value + Math.floor(Math.random() * 10) + 1;
    if (this.value >= 100) {
        this.value = 100;
        clearInterval(interval);
    }
}, 2000);
this.es = {
  firstDayOfWeek: 1,
  dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
  dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
  dayNamesMin: [ "D","L","M","X","J","V","S" ],
  monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
  monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
  today: 'Hoy',
  clear: 'Borrar'
}
let today = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  let prevMonth = (month === 0) ? 11 : month -1;
  let prevYear = (prevMonth === 11) ? year - 1 : year;
  let nextMonth = (month === 11) ? 0 : month + 1;
  let nextYear = (nextMonth === 0) ? year + 1 : year;
  this.minDate = new Date();
  this.minDate.setMonth(prevMonth);
  this.minDate.setFullYear(prevYear);
  this.maxDate = new Date();
  this.maxDate.setMonth(nextMonth);
  this.maxDate.setFullYear(nextYear);

  let invalidDate = new Date();
  invalidDate.setDate(today.getDate() - 1);
  this.invalidDates = [today,invalidDate];
}

showBasicDialog() {
  this.displayBasic = true;
}

}
